<template>
  <div class="container">
    <HeaderView />
    <div
      :class="{
        'bg-content': $store.state.screenWidth > 375,
        'bg-content-se': $store.state.screenWidth <= 375,
        'bg-content-4': $store.state.screenWidth <= 320,
      }"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-4">
            <h2
              :class="{
                'mt-3': $store.state.screenWidth <= 320,
                'mt-5': $store.state.screenWidth > 320,
              }"
              style="font-family: 'Mitr', sans-serif; font-size: 30px;"
            >
              <img src="/static/img/icons/apple-touch-icon-60x60.png" />
              &nbsp;เข้าร่วมงาน
            </h2>
            <div
              :class="{
                'mt-3 mb-3': $store.state.screenWidth <= 320,
                'mt-4 mb-4': $store.state.screenWidth > 320,
              }"
            >
              <label for="citizen" class="mb-2">
                รหัสบัตรประชาชนหรือเลขพาสปอร์ต
              </label>
              <input
                class="form-control"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                maxlength="13"
                v-model="citizen_id"
                id="citizen"
                autocomplete="off"
                @keyup="checkVal = false"
                @keyup.enter="validateForm"
              />
              <small class="text-danger" v-if="checkVal">
                กรุณากรอกรหัสประจำตัวประชาชนหรือเลขพาสปอร์ตให้ถูกต้อง
              </small>
            </div>
            <button
              class="btn bg-rmutl text-white"
              style="
                width: 100%;
                font-size: 22px;
                font-family: 'Mitr', sans-serif;
              "
              @click="validateForm"
            >
              <i class="ti ti-login"></i>
              &nbsp;เข้าสู่ระบบ
            </button>
            <div
              class="mt-4 text-center"
              style="font-family: 'Mitr', sans-serif; color: gray;"
              :style="{
                'font-size': $store.state.screenWidth <= 320 ? '11px' : '14px',
              }"
            >
              เปิดบ้านราชมงคลล้านนา
              <br />
              RMUTL OPEN HOUSE
              <br />
              เรียนรู้ สร้างสรรค์ เทคโนโลยี ก้าวสู่อาชีพ
              <br />
              พัฒนาโดย
              <a
                href="https://www.facebook.com/ARITRMUTL.Official"
                target="_blank"
              >
                สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
              </a>
            </div>
          </div>
          <div class="col-sm-4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  components: {
    HeaderView,
  },
  data() {
    return {
      citizen_id: '',
      checkVal: false,
    }
  },
  methods: {
    validateForm() {
      if (this.citizen_id.length === 13) {
        if (this.THAIIDCHECK(this.citizen_id) === true) {
          this.Login(this.citizen_id)
        } else {
          this.checkVal = true
        }
      } else if (this.citizen_id.length === 9) {
        this.Login(this.citizen_id)
      } else {
        this.checkVal = true
      }
    },
    Login(citizenId) {
      this.$store.state.isLoading = true
      api.OAuthCheck(
        this.$store.state.URL,
        { citizenId: citizenId },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            localStorage.token = result.data.accessToken
            this.OAuth(citizenId)
            this.$router.push('/activity').catch(() => {})
          } else if (result.status === 'NOT_REGISTER') {
            this.$router.push('/regis/' + citizenId).catch(() => {})
          } else {
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: 'ลองใหม่อีกครั้ง',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.Login()
              } else if (result.isDenied) {
                this.citizen_id = ''
              }
            })
            localStorage.clear()
          }
          this.$store.state.isLoading = false
        },
        (error) => {
          this.$store.state.isLoading = false
          Swal.fire({
            title: 'ตรวจสอบ',
            text: JSON.stringify(error),
            icon: 'error',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            denyButtonText: 'ยกเลิก',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.Login()
            } else if (result.isDenied) {
              this.citizen_id = ''
            }
          })
        },
      )
    },
  },
  mounted() {
    const auth = this.callbackToken(this.citizen_id)
    if (auth) {
      this.$router.push('/activity').catch(() => {})
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue